import HeroBg from "public/dedicated-server/dedicateServerBg.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Contact Us",
    link: "contact-us",
  },
  title: "Policies & Procedures for OneMind Services",
  desc: "Explore our comprehensive policies and procedures designed to ensure the highest standards of service delivery and customer satisfaction.",
  image: HeroBg,
};
